// extracted by mini-css-extract-plugin
export default {"itemChip":"MenuLayout_itemChip__j8Wc3"};